<template>
  <div class="select-role auth-view">
    <div class="form-wrap">
      <div class="form">

        <MainLogo/>
        <!-- <p>Please, register to choose your plan and proceed to the payment</p> -->
        <!-- <p>{{$ml.get(`Please, register to choose your plan and proceed to the payment`)}}</p> -->
        <!-- TODO добавить перевод в label -->
        <app-sel
          v-model="role"
          filterable
          :items="roles"
          :label="$ml.get(`Select your role`)"
        >
          <template v-slot="{ items }">
            <app-sel-opt
              v-for="item in items"
              :value="item"
              :key="item.key"
            >
              {{ item.label }}
            </app-sel-opt>
          </template>
        </app-sel>
<!--
        <app-text-input
          v-if="haveReferralCode"
          :label="'Refferal code'"
          v-model="referralCode"
          :type="'text'"
          :info-tip="$ml.get(`If exists`)"
        /> -->

        <btn @click="confirmRole">{{$ml.get(`next`)}}</btn>

      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import MainLogo from '@/components/auth/MainLogo';

export default {
  data() {
    return {
      role : null,
      roles: [
        {
          label : this.$ml.get("Farmer"),
          key : "farmer",
        },
        {
          label : this.$ml.get("Advisor"),
          key : "advisor",
        },
        {
          label : this.$ml.get("Company"),
          key : "company",
        },
        {
          label : this.$ml.get("Institution"),
          key : "institution",
        },
      ],
      haveReferralCode : false,
      referralCode : null,
      refUserId : null,
    }
  },
  created() {
    // @FACEBOOK-PIXEL
    fbq('track', 'InitiateCheckout');

    this.checkRefLink();
  },
  methods : {
    confirmRole() {
      // console.log(this.role.value);
      if(this.role) {
        this.$router.push({ name : 'auth-register', params : { role : this.role, refUserId : this.refUserId } })
      }else {
        this.$notify({
          group: 'notices',
          title: 'Please select role!',
          type : 'error',
        });
      }

    },
    checkRefLink() {
      if(this.$route.query.ref) {
        this.haveReferralCode = true;
        this.referralCode = this.$route.query.ref;
        return API.user.checkRefLink(this.referralCode).then(res => {
          console.log(res);
          this.refUserId = res.data.data;
          this.$router.push({ name : 'auth-register', params : { role : 'farmer', refUserId : this.refUserId } })
        });
      }
    }
  },
  watch : {
    role : function() {
      console.log(this.role);
      if(this.role == 'farmer') {
        this.haveReferralCode = true;
      } else {
        this.haveReferralCode = false;
      }
    }
  },

  components: {
    MainLogo,
  },
}
</script>

<style lang="scss" scoped>
.select-role {

  .form-wrap {

    .form {
      width: 400px;
      .app-sel {
        margin-bottom: 16px;
        margin-top: 24px;
      }
      .logo {
        margin-bottom: 0;
      }
      p {
        margin-bottom: 32px;
      }
      .app-text-input {
        margin-top: 32px;
        margin-bottom: 24px;
      }
    }
    @media(max-width: 768px) {
      .form {
        width: 100%;
      }
    }
  }
}
</style>
